export const ARCHIVED_FIELD = 'hs_archived_in_dashboard';
export const AUTHOR_FIELD = 'hs_created_by_user_id__eq';
export const KNOWLEDGE_CATEGORY_FIELD = 'hs_knowledge_category_id__in';
export const LANGUAGE_FIELD = 'hs_language__eq';
export const ORDER_FIELD = 'order';
export const SEARCH_FIELD = 'hs_name__icontains';
export const STATE_FIELD = 'hs_state';
export const VISIBILITY_LISTS_FIELD = 'hs_access_rule_ids__in';
export const VISIBILITY_TYPE_FIELD = 'hs_access_rule_type__in';
export const GROUP_ID_FIELD = 'hs_group_id';
export const FILTERS_FOR_ARTICLES_COUNT = [AUTHOR_FIELD, KNOWLEDGE_CATEGORY_FIELD, VISIBILITY_LISTS_FIELD, VISIBILITY_TYPE_FIELD];
export const FILTERS_FOR_BULK_OPERATIONS = [ARCHIVED_FIELD, AUTHOR_FIELD, KNOWLEDGE_CATEGORY_FIELD, SEARCH_FIELD, STATE_FIELD, VISIBILITY_LISTS_FIELD, VISIBILITY_TYPE_FIELD];